module.exports = {
  'name': 'expm1',
  'category': 'Arithmetic',
  'syntax': [
    'expm1(x)'
  ],
  'description': 'Calculate the value of subtracting 1 from the exponential value.',
  'examples': [
    'expm1(2)',
    'pow(e, 2) - 1',
    'log(expm1(2) + 1)'
  ],
  'seealso': [
    'exp',
    'pow',
    'log'
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/expm1.js
// module id = 1467
// module chunks = 0